import React from "react";
import { useSelector } from "react-redux";

import { selectLoginState, selectUserInfo } from "../redux/User";
import { NotFound } from "../component";
import { Login } from "../screen";
import Layout from "../layout";

interface Role {
  roleTypeId: number;
  description: string;
}

interface ProtectedProps {
  roleTypeId: number;
  children: React.ReactNode;
}

const Protected:React.FC<ProtectedProps> = ({
  roleTypeId,
  children,
}) => {

  const { isLoggedIn, userInfo } = useSelector((store: any) => ({
    isLoggedIn: selectLoginState(store),
    userInfo: selectUserInfo(store),
  }));

  return (
    <>
      {
        isLoggedIn
        ? (userInfo?.roles?.map((userRole: Role) => userRole.roleTypeId)?.includes(roleTypeId)
          ? <Layout>{children}</Layout>
          : <Layout><NotFound /></Layout>)
        : <Login />
      }
    </>
  );
};

export default Protected;
